export default __webpack_public_path__ + "static/media/ppp.047cbb5b.jpg";